module.exports = __webpack_public_path__ + "static/media/logo.fca95db5.png";